export default "__VITE_ASSET__CsWPSOiE__"